// extracted by mini-css-extract-plugin
export default {"cancelScreen":"CancelScreen_cancelScreen__pu5D7"};